import { render, staticRenderFns } from "./InspectionReminderForm.vue?vue&type=template&id=d0e9716a"
import script from "./InspectionReminderForm.vue?vue&type=script&lang=js"
export * from "./InspectionReminderForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports